import {
  xdlColorTextTertiary,
  xdlColorSelected,
  xdlColorControlFill,
} from '@xingternal/tokens';

const modifiersStyles = {
  disabled: {
    color: xdlColorTextTertiary,
    cursor: 'default',
  },
  selected: {
    'background-color': xdlColorSelected,
    'border-radius': '20px',
    color: xdlColorControlFill,
    'font-weight': 'bold',
  },
};

export { modifiersStyles };
